import React from "react";
import { Box, Typography, Paper } from "@mui/material";

// Section components (placeholder)
export const SectionContainer: React.FC<{
  id: string;
  title: string;
  children: React.ReactNode;
}> = ({ id, title, children }) => (
  <Box id={id} sx={{ mb: 4, scrollMarginTop: "80px" }}>
    <Typography variant="h5" sx={{ mb: 2, color: "white" }}>
      {title}
    </Typography>
    <Paper sx={{ p: 3, bgcolor: "background.paper" }}>{children}</Paper>
  </Box>
);
